import type { HTMLAttributes, ReactNode } from 'react';

import { buildClassName } from '@utils';

import './Container.css';

export type ContainerSize = 'sm' | 'md' | 'lg' | 'xl' | 'full';

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Container max-width size
   * @default 'lg'
   */
  size?: ContainerSize;
  /**
   * Container content
   */
  children: ReactNode;
}

export function Container({
  size = 'lg',
  className = '',
  children,
  ...props
}: ContainerProps) {
  const containerClasses = buildClassName(
    'bhg-container',
    `bhg-container--${size}`,
    className
  );

  return (
    <div className={containerClasses} {...props}>
      {children}
    </div>
  );
}
